import React, { createContext, useState, useCallback, useRef } from "react";

const ConnectionContext = createContext();

const CONNECTION_STATUS = {
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
  RECONNECTING: "reconnecting",
};

const ConnectionProvider = ({ children }) => {
  const [connectionStatus, setConnectionStatus] = useState(
    CONNECTION_STATUS.CONNECTED
  );
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [lastDisconnectedAt, setLastDisconnectedAt] = useState(null);
  const [lastConnectedAt, setLastConnectedAt] = useState(null);
  const [connectionError, setConnectionError] = useState(null);

  const prevStatusRef = useRef(CONNECTION_STATUS.CONNECTED);

  const onDisconnected = useCallback((reason) => {
    setConnectionStatus(CONNECTION_STATUS.DISCONNECTED);
    setLastDisconnectedAt(Date.now());
    setConnectionError(reason || null);
    prevStatusRef.current = CONNECTION_STATUS.DISCONNECTED;
  }, []);

  const onReconnecting = useCallback((attemptNumber) => {
    setConnectionStatus(CONNECTION_STATUS.RECONNECTING);
    setReconnectAttempts(attemptNumber);
    prevStatusRef.current = CONNECTION_STATUS.RECONNECTING;
  }, []);

  const onConnected = useCallback(() => {
    const wasDisconnected =
      prevStatusRef.current !== CONNECTION_STATUS.CONNECTED;

    setConnectionStatus(CONNECTION_STATUS.CONNECTED);
    setLastConnectedAt(Date.now());
    setReconnectAttempts(0);
    setConnectionError(null);
    prevStatusRef.current = CONNECTION_STATUS.CONNECTED;

    return wasDisconnected;
  }, []);

  const onReconnectError = useCallback((error) => {
    setConnectionError(error?.message || "Erro de reconexão");
  }, []);

  const value = {
    connectionStatus,
    reconnectAttempts,
    lastDisconnectedAt,
    lastConnectedAt,
    connectionError,
    isConnected: connectionStatus === CONNECTION_STATUS.CONNECTED,
    isDisconnected: connectionStatus === CONNECTION_STATUS.DISCONNECTED,
    isReconnecting: connectionStatus === CONNECTION_STATUS.RECONNECTING,
    onDisconnected,
    onReconnecting,
    onConnected,
    onReconnectError,
  };

  return (
    <ConnectionContext.Provider value={value}>
      {children}
    </ConnectionContext.Provider>
  );
};

export { ConnectionContext, ConnectionProvider, CONNECTION_STATUS };
export default ConnectionContext;
